import { render, staticRenderFns } from "./mailSettingGet.vue?vue&type=template&id=714f548c&scoped=true&"
import script from "./mailSettingGet.vue?vue&type=script&lang=js&"
export * from "./mailSettingGet.vue?vue&type=script&lang=js&"
import style0 from "./mailSettingGet.vue?vue&type=style&index=0&id=714f548c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f548c",
  null
  
)

export default component.exports